import React, { Component } from 'react';
import { Grid } from "@material-ui/core";
import SingleSlider from "./SingleSlider";

class Sliders extends Component {
  constructor(props) {
    super(props);
    this.changeSlider = this.changeSlider.bind(this);
    this.changeCheckbox = this.changeCheckbox.bind(this);
    this.slidersAr = this.props.settings.sliders.map(slider => slider.id);
    this.refSliders = this.slidersAr.reduce((refs, id) => {
      refs[id] = React.createRef();
      return refs;
    }, {});
    this.filterData = this.slidersAr.reduce((filters, id) => {
      filters[id] = this.props.metadata.map(item => item[id]);
      return filters;
    }, {});
    this.filtered = {};
    this.state = {
      datafilter: this.filterData
    };
  }

  changeSlider(componentName, value) {
    const { metadata, settings, calculateProjection } = this.props;
    this.filtered[componentName] = new Float32Array(settings["total"]).fill(0);
    let filteredArr = new Float32Array(settings["total"]);

    metadata.forEach((element, index) => {
      if (value != element[componentName]) {
        this.filtered[componentName][index] = 1;
      }
    });

    let list = Object.values(this.filtered);
    let arr = filteredArr.map((_, idx) => list.reduce((max, curr) => max + curr[idx], 0));
    calculateProjection(arr, "filter", true);
  }

  changeCheckbox = (componentName, isChecked) => {
    const { metadata, settings, calculateProjection } = this.props;
    if (isChecked) {
      // If the checkbox is checked, reset the filter for this component
      this.filtered[componentName] = new Float32Array(settings["total"]).fill(0);
    } else {
      // If the checkbox is not checked, filter based on the slider value
      this.filtered[componentName] = new Float32Array(settings["total"]).fill(0);
      metadata.forEach((element, index) => {
        if (element[componentName] !== this.refSliders[componentName].current.state.value) {
          this.filtered[componentName][index] = 1;
        }
      });
    }

    let list = Object.values(this.filtered);
    let arr = new Float32Array(settings["total"]).map((_, idx) => list.reduce((max, curr) => max + curr[idx], 0));
    calculateProjection(arr, "filter", true);
  }

  render() {
    const { hover_index, settings } = this.props;
    const slidersSettings = settings['sliders'];
    const SliderList = slidersSettings.map((slider) => (
      // <Grid item key={slider['id']}>
        <SingleSlider
          ref={this.refSliders[slider['id']]}
          datafilter={this.state.datafilter[slider['id']]}
          // title={slider['title']}
          id={slider['id']}
          // info={slider['info']}
          // typeNumber={slider['typeNumber']}
          // color={slider['color']}
          onChangeSlider={this.changeSlider}
          onChangeCheckbox={this.changeCheckbox}
          // hover_index={hover_index}
          // barData={barData[slider['id']]}
          // calculateProjection={this.props.calculateProjection}
          // currentProjection={this.props.currentProjection}
          // settings={settings}
          // sliderID={slider['id']}
          // metadata={this.props.metadata}
          range={[slider['min'], slider['max']]}
        />
      // </Grid>
    ));

    return (
      <Grid container>
        {SliderList}
      </Grid>
    );
  }
}

export default Sliders
